import React, { useState } from 'react';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router';

const ContactNotUpdate = () => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate()

  return (
    <div style={{
      width: '100%',
      background: 'linear-gradient(140deg, #000000 0%, #6f6f6f 100%)',
      borderRadius: '4px',
      overflow: 'hidden',
      textAlign: 'center'
    }}>
      <div style={{
        height: '4px',
        width: '100%'
      }} />
      
      <div style={{ padding: '60px 40px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '32px' }}>
          <div style={{
            width: '80px',
            height: '80px',
            backgroundColor: '#2a2a2a',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '3px solid white',
          }}>
            <AlertTriangle size={36} color="white" />
          </div>
        </div>
        
        <h2 style={{
          fontSize: '20px',
          fontWeight: '700',
          color: '#ffffff',
          margin: '0 0 12px 0',
          lineHeight: '1.3'
        }}>
          Please update your contact information.
        </h2>
        
        <p style={{
          color: '#a0a0a0',
          fontSize: '14px',
          lineHeight: '1.6',
          margin: '0 0 30px 0',
          maxWidth: '360px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>
          Your contact information needs to be updated before you can proceed with your request.
        </p>
        
        <button
          onClick={() => navigate('/profile?update=contact')}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            padding: '12px 24px',
            backgroundColor: 'white',
            border: 'none',
            borderRadius: '8px',
            color: 'black',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            transform: isHovered ? 'translateX(5px)' : 'translateX(0)',
          }}
        >
          Update Contact Information
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  )}

  export default ContactNotUpdate